export enum TaskManager {
  GET_PENDING_TASKS = "GET_PENDING_TASKS",
  GET_PENDING_TASKS_SUCCESS = "GET_PENDING_TASKS_SUCCESS",
  GET_PENDING_TASKS_FAIL = "GET_PENDING_TASKS_FAIL",

  GET_GROUPS = "GET_GROUPS",
  GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS",
  GET_GROUPS_FAIL = "GET_GROUPS_FAIL",

  GET_TASKS = "GET_TASKS",
  GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS",
  GET_TASKS_FAIL = "GET_TASKS_FAIL",

  MANAGE_TASK_DRAWER = "MANAGE_TASK_DRAWER",

  CREATE_GROUP = "CREATE_GROUP",
  CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS",
  CREATE_GROUP_FAIL = "CREATE_GROUP_FAIL",

  UPDATE_GROUP = "UPDATE_GROUP",
  UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS",
  UPDATE_GROUP_FAIL = "UPDATE_GROUP_FAIL",

  CREATE_TASK = "CREATE_TASK",
  CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS",
  CREATE_TASK_FAIL = "CREATE_TASK_FAIL",

  UPDATE_TASK = "UPDATE_TASK",
  UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS",
  UPDATE_TASK_FAIL = "UPDATE_TASK_FAIL",

  DELETE_TASK = "DELETE_TASK",
  DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS",
  DELETE_TASK_FAIL = "DELETE_TASK_FAIL",

  DELETE_GROUP = "DELETE_GROUP",
  DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS",
  DELETE_GROUP_FAIL = "DELETE_GROUP_FAIL",

  GET_TASK = "GET_TASK",
  GET_TASK_SUCCESS = "GET_TASK_SUCCESS",
  GET_TASK_FAIL = "GET_TASK_FAIL",

  GET_TASK_HISTORY = "GET_TASK_HISTORY",
  GET_TASK_HISTORY_SUCCESS = "GET_TASK_HISTORY_SUCCESS",
  GET_TASK_HISTORY_FAIL = "GET_TASK_HISTORY_FAIL",

  GET_INSTANCE_HISTORY = "GET_INSTANCE_HISTORY",
  GET_INSTANCE_HISTORY_SUCCESS = "GET_INSTANCE_HISTORY_SUCCESS",
  GET_INSTANCE_HISTORY_FAIL = "GET_INSTANCE_HISTORY_FAIL",

  SAVE_TASK_INSTANCE = "SAVE_TASK_INSTANCE",
  SAVE_TASK_INSTANCE_SUCCESS = "SAVE_TASK_INSTANCE_SUCCESS",
  SAVE_TASK_INSTANCE_FAIL = "SAVE_TASK_INSTANCE_FAIL",

  GET_OPERATIONS_HANDLERS = "GET_OPERATIONS_HANDLERS",
  GET_OPERATIONS_HANDLERS_SUCCESS = "GET_OPERATIONS_HANDLERS_SUCCESS",
  GET_OPERATIONS_HANDLERS_FAIL = "GET_OPERATIONS_HANDLERS_FAIL",

  GET_USERS = "GET_USERS",
  GET_USERS_SUCCESS = "GET_USERS_SUCCESS",
  GET_USERS_FAIL = "GET_USERS_FAIL",

  SEND_EMAIL = "SEND_EMAIL",
  SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS",
  SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL",

  RUN_TASK = "RUN_TASK",
  RUN_TASK_SUCCESS = "RUN_TASK_SUCCESS",
  RUN_TASK_FAIL = "RUN_TASK_FAIL",

  GET_SCRIPTS = "GET_SCRIPTS",
  GET_SCRIPTS_SUCCESS = "GET_SCRIPTS_SUCCESS",
  GET_SCRIPTS_FAIL = "GET_SCRIPTS_FAIL",
}
